import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/Relatorio";

/**
 * Classe de gerenciamento de chamadas da API da dashboard
 *
 * @class
 */
export default class DashboardApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api: $Fetch;

  /**
   * Cria uma nova instância da classe ModuleApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Obtém a estrutura de dashboard para um relatório específico
   * @param codRelatorio - Código do relatório
   * @returns Objeto com as informações do dashboard
   */
  public get(codRelatorio: number) {
    return this.api<string>(`${controller}/GetEstruturaDashboard`, {
      method: "GET",
      query: {
        codRelatorio,
      },
    });
  }

  /**
   * Realiza o cadastro de uma estrutura de dashboard
   * @param codRelatorio - Código do relatório
   * @param estruturaRelatorio - Estrutura do dashboard em json string
   * @returns boolean
   */
  public post(codRelatorio: number, estruturaRelatorio: string) {
    return this.api<boolean>(`${controller}/PostEstruturaDashboard`, {
      method: "POST",
      body: {
        CodRelatorio: codRelatorio,
        EstruturaDashboard: estruturaRelatorio,
      },
    });
  }
}
